module.exports = __webpack_public_path__ + "img/upload-outdated.552bf8c3.svg";